import React, { ReactNode } from 'react';
import { ResponsiveContainer } from 'recharts';

import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { ConversationalAnalyticsChartProps } from '@atom/types/conversationalAnalytics';
import { CHART_HEIGHT } from '@atom/utilities/conversationalAnalyticsUtilities';

import useConversationalAnalyticsData from './hooks/useConversationalAnalyticsData';
import ConversationalAnalyticsChartWrapper from './ConversationalAnalyticsChartWrapper';

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    padding: '1rem',
  },
  textItem: {
    fontSize: fonts.md,
    color: colors.neutral.dark,
  },
};

const ConversationalAnalyticsTextChart: React.FC<
  ConversationalAnalyticsChartProps
> = ({ spec, width = '100%', height, onExport }) => {
  const { chartData, xDisplayField, yField } =
    useConversationalAnalyticsData(spec);

  return (
    <ConversationalAnalyticsChartWrapper spec={spec} onExport={onExport}>
      <ResponsiveContainer width={width} height={height || CHART_HEIGHT}>
        <div style={styles.container}>
          {chartData.map((item, index) => {
            const content: ReactNode = `${item[xDisplayField]}: ${item[yField]}`;

            return (
              <div key={index} style={styles.textItem}>
                {content}
              </div>
            );
          })}
        </div>
      </ResponsiveContainer>
    </ConversationalAnalyticsChartWrapper>
  );
};

export default ConversationalAnalyticsTextChart;
